import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function FeaturesSectionHoverEffectsReactjs() {
    const features = [
        {
            title: 'Custom ReactJS Development',
            description:
                'We transform your unique ideas into reality, crafting bespoke ReactJS solutions that perfectly align with your vision and business objectives.',
            icon: '/img/technology/ic-customized-laravel-development.svg',
        },
        {
            title: 'ReactJS Migration and Porting Services',
            description:
                'Seamlessly migrate your legacy applications to ReactJS, unlocking improved performance, maintainability, and user experience.',
            icon: '/img/technology/ic-data-migration.svg',
        },
        {
            title: 'ReactJS Consulting Services',
            description:
                'Gain expert insights and guidance from our seasoned ReactJS consultants to architect scalable, high-performance solutions and make informed technology decisions.',
            icon: '/img/technology/ic-consulting-services.svg',
        },
        {
            title: 'React Mobile App Development',
            description:
                "Leverage the power of React Native to build cross-platform mobile apps that deliver native-like performance and exceptional user experiences across iOS and Android platforms.",
            icon: '/img/technology/ic-iphone-app.svg',
        },
        {
            title: 'React Web App Development',
            description:
                'Create dynamic and interactive web applications that captivate users, drive engagement, and convert visitors into loyal customers.',
            icon: '/img/technology/ic-ipad-development.svg',
        },
        {
            title: 'React Web Portal Development',
            description:
                'Develop feature-rich and user-friendly web portals that streamline processes, facilitate collaboration, and enhance user interactions.',
            icon: '/img/technology/ic_portaldevelopment.svg',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: string;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 5 && 'dark:border-neutral-800 ',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
